<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">Annual Production Report</h3>
      <b-row>
        <b-col md="4">
          <b-row>
            <b-col md="4" lg="3">
              <base-input label="Active Members" label-for="active">
                <base-switch class="mr-1" v-model="active"></base-switch>
              </base-input>
            </b-col>
            <b-col md="8" lg="9">
              <base-input label="Team Members" sr-only-label label-for="yearInput" v-if="team" placeholder="Select an Agent">
                <el-select v-model="member" @change="getItems" v-if="team">
                  <el-option v-for="member in team"
                             :key="member.slug"
                             :label="member.name"
                             :value="member.id">
                  </el-option>
                </el-select>
              </base-input>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <base-input label="Period" label-for="yearInput">
            <el-select v-model="period">
              <el-option value="monthly" label="Monthly"></el-option>
              <el-option value="quarterly" label="Quarterly"></el-option>
            </el-select>
          </base-input>
        </b-col>
        <b-col md="4">
          <base-input label="Year" label-for="yearInput">
            <el-select v-model="year">
              <el-option v-for="year in years"
                         :key="year.label"
                         :label="year.label"
                         :value="year.value">
              </el-option>
            </el-select>
          </base-input>
        </b-col>
      </b-row>
    </b-card-header>
    <agent-production-table :items="items" v-if="items"></agent-production-table>
    <loading-panel v-else></loading-panel>
  </b-card>
</template>

<script>
import axios from 'axios';
import {Select, Option} from 'element-ui'
import LoadingPanel from '@/components/LoadingPanel';
import AgentProductionTable from '@/views/Components/Tables/AgentProductionTable';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    LoadingPanel,
    AgentProductionTable,
  },
  props: {
    userRoute: null
  },
  data() {
    return {
      period: 'monthly',
      year: new Date().getFullYear(),
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
      items: null,
      member: null,
      team: null,
      active: true
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/reports/agent-production/" + this.member + "/" + this.period + "?year=" + this.year)
      .then(response => {
        this.items = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getTeam() {
      const active = this.active ? 1 : 0;
      axios.get(this.userRoute + "/members/team?active=" + active)
      .then(response => {
        this.team = response.data;
        this.member = response.data[0].id;
        if(this.member) {
          this.getItems();
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
  },
  created() {
    this.getTeam();
  },
  watch: {
    period(to, from) {
      this.getItems();
    },
    year(to, from) {
      this.getItems();
    },
    active(to, from) {
      this.getTeam();
    }
  }
};
</script>